import Text from 'components/Text/Text';
import React, { useContext, useEffect, useMemo } from 'react';
import { Form } from 'antd';
import NameField from './components/NameField';
import SurNameField from './components/SurNameField';
import EmailField from './components/EmailField';
import RoleSelect from './components/RoleSelect';
import BtnBlock from './components/BtnBlock';
import PhoneField from './components/PhoneField';
import AdditionalFields from './components/AdditionalFields';
import { UserRoles } from 'types';
import { getFileIdForSubmit, preventDefaultForEnterKey } from 'utils/helpers';
import { EditUserContext, IEditUserContext } from '../../../../editUserState/editUserContext';
import style from './InputFields.module.scss';

const InputFields: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		changeName,
		changeSurName,
		changeEmail,
		changePhoneNumber,
		setRole,
		setFetchedRoles,
		setCustomer,
		setCustomers,
		setFetchedCustomers,
		setRestaurants,
		setFetchedRestaurants,
		userID,
		fileId,
		filePath,
		name,
		surName,
		email,
		phoneNumber,
		selectedRole,
		fetchedRoles,
		selectedCustomer,
		selectedCustomers,
		selectedRestaurants,
		initialIDsSelectedRestaurant,
		fetchedRestaurants,
	} = useContext<IEditUserContext>(EditUserContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			name,
			surName,
			email,
			phoneNumber,
			selectedRole,
			selectedCustomer,
			selectedCustomers,
			selectedRestaurants,
		});
	}, [name, surName, email, phoneNumber, selectedRole, selectedCustomer, selectedCustomers, selectedRestaurants]);

	const roleName = useMemo(
		() => fetchedRoles.find((el) => el.id === selectedRole)?.name,
		[fetchedRoles, selectedRole],
	);

	const submit = async () => {
		const customerId =
			roleName === UserRoles.CLIENT_MANAGER || roleName === UserRoles.RESTAURANT_MANAGER
				? selectedCustomer
				: null;
		const customerIds = roleName === UserRoles.GROUP_MANAGER ? selectedCustomers : null;
		const restaurantIds = roleName === UserRoles.RESTAURANT_MANAGER ? selectedRestaurants : null;

		setDataForSubmit({
			id: userID,
			firstName: name,
			surName,
			email,
			roleId: selectedRole || '',
			phoneNumber,
			customerId,
			customerIds,
			restaurantIds,
			fileId: getFileIdForSubmit({ fileId, filePath }),
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<NameField changeName={changeName} />
					<SurNameField changeSurName={changeSurName} />
					<EmailField changeEmail={changeEmail} />
					<PhoneField changePhoneNumber={changePhoneNumber} />
					<RoleSelect setRole={setRole} setFetchedRoles={setFetchedRoles} />
					<AdditionalFields
						roleName={roleName || ''}
						selectedCustomer={selectedCustomer}
						selectedCustomers={selectedCustomers}
						selectedRestaurants={selectedRestaurants}
						initialIDsSelectedRestaurant={initialIDsSelectedRestaurant}
						setCustomer={setCustomer}
						setCustomers={setCustomers}
						setFetchedCustomers={setFetchedCustomers}
						setRestaurants={setRestaurants}
						setFetchedRestaurants={setFetchedRestaurants}
					/>
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};

export default InputFields;
